function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueBox = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _Button = require("../Button");
var _reactI18next = require("react-i18next");
var _styles = require("./styles");
var _styles2 = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["value", "style", "label", "Image", "imageSize", "imageContainerStyle", "imageStyle", "linkText", "linkURL", "description", "isLandscape"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var ValueBox = exports.ValueBox = (0, _react.memo)(function (_ref) {
  var value = _ref.value,
    style = _ref.style,
    label = _ref.label,
    Image = _ref.Image,
    _ref$imageSize = _ref.imageSize,
    imageSize = _ref$imageSize === void 0 ? (0, _styles2.getREM)(5) : _ref$imageSize,
    imageContainerStyle = _ref.imageContainerStyle,
    imageStyle = _ref.imageStyle,
    linkText = _ref.linkText,
    linkURL = _ref.linkURL,
    description = _ref.description,
    _ref$isLandscape = _ref.isLandscape,
    isLandscape = _ref$isLandscape === void 0 ? false : _ref$isLandscape,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)({
      isLandscape: isLandscape
    }),
    styles = _useStyles.styles;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _isPointerOver = _useState2[0],
    _setIsPointerOver = _useState2[1];
  var _hasLabel = !!label;
  var _hasImage = !!Image;
  var _hasLink = !!linkText && !!linkURL;
  var _hasDescription = !!description;
  var _onPointerEnter = function _onPointerEnter() {
    _setIsPointerOver(true);
  };
  var _onPointerLeave = function _onPointerLeave() {
    _setIsPointerOver(false);
  };
  return (0, _jsxRuntime.jsxs)(_reactNative.View, Object.assign({
    style: [styles.container, style, isLandscape && styles.container_flat, _isPointerOver && styles.container_pointerOver]
  }, props, {
    children: [(0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: styles.primaryContentContainer,
      children: [(0, _jsxRuntime.jsxs)(_reactNative.View, {
        style: styles.primaryContentText,
        children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
          textBreakStrategy: "simple",
          style: styles.value,
          children: t('format:number', {
            value: value
          })
        }), _hasLabel && (0, _jsxRuntime.jsx)(_reactNative.Text, {
          textBreakStrategy: "simple",
          style: styles.label,
          children: label
        })]
      }), _hasImage && (0, _jsxRuntime.jsx)(_reactNative.View, {
        style: styles.primaryContentImage,
        children: (0, _jsxRuntime.jsx)(_reactNative.View, {
          style: [styles.imageContainer, {
            width: imageSize,
            height: imageSize
          }, imageContainerStyle],
          children: (0, _jsxRuntime.jsx)(Image, {
            testID: "ValueBoxImage",
            style: [styles.image, imageStyle]
          })
        })
      })]
    }), _hasDescription && (0, _jsxRuntime.jsx)(_reactNative.Text, {
      textBreakStrategy: "simple",
      style: styles.description,
      children: description
    }), _hasLink && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)(_Button.Button, {
        type: _Button.ButtonType.link,
        isFake: true,
        label: linkText,
        textStyle: styles.fakeLink
      }), (0, _jsxRuntime.jsx)(_Button.Button, {
        type: _Button.ButtonType.blank,
        label: linkText,
        containerStyle: styles.linkContainer,
        textStyle: styles.linkText,
        href: linkURL,
        hideLabel: true,
        onPointerEnter: _onPointerEnter,
        onPointerLeave: _onPointerLeave,
        testID: "ValueBoxLink"
      })]
    })]
  }));
});